import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FocusEventHandler, KeyboardEventHandler, useState } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { SErrorLabel, SIcon, SInput, SLabel, SWrapper } from './styles/BootsrapInput.styled';

interface IProps {
  label: string;
  isPassword?: boolean;
  isError: boolean;
  register: UseFormRegisterReturn;
  errorLabel?: string;
  onKeyDown?: KeyboardEventHandler;
  onBlur?: FocusEventHandler;
}

function BootstrapInput({ label, isPassword, isError, register, errorLabel, onKeyDown, onBlur }: IProps) {
  const [isTextVisible, setIsTextVisible] = useState(!isPassword);
  const id = label.replace(/ /g, '');

  return (
    <SWrapper>
      <SLabel htmlFor={`txt${id}`} id={`lbl${id}`}>
        {label}
      </SLabel>
      <div className="d-flex" style={{ position: 'relative' }}>
        <SInput
          id={`txt${id}`}
          spellCheck={false}
          className="form-control shadow-none"
          type={isTextVisible ? 'text' : 'password'}
          autoComplete={isPassword ? 'current-password' : 'username'}
          isError={errorLabel ? true : false || isError}
          {...register}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
        />
        {isPassword ? (
          <SIcon id="btnVisibility" onClick={() => setIsTextVisible(!isTextVisible)}>
            <FontAwesomeIcon icon={isTextVisible ? faEyeSlash : faEye} />
          </SIcon>
        ) : null}
      </div>
      <SErrorLabel id={`txt${id}-error`}>{errorLabel}</SErrorLabel>
    </SWrapper>
  );
}

BootstrapInput.defaultProps = {
  isPassword: false,
};

export default BootstrapInput;
